/** Pick-next label confirmation. The QR payload is the order number alone. */
export function qrConfirmsOrder(
  scanned: string | null | undefined,
  orderNumber: string | number,
): boolean {
  if (scanned == null) return false;
  const payload = scanned.trim();
  const expected = String(orderNumber).trim();
  if (!payload || !expected) return false;
  return payload === expected;
}
